// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-rotate[data-v-d63de746]{transform:rotate(-7deg);overflow:hidden}", ""]);
// Exports
module.exports = exports;
